var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.997,
    height: 33.144,
    viewBox: "0 0 35.997 33.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6453",
    "data-name": "Group 6453",
    transform: "translate(-932.477 -1788.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M-2197.867,14905.18v-16.31h32.018v16.31",
    transform: "translate(3132.268 -13100.001)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_444",
    "data-name": "Ellipse 444",
    transform: "translate(940.777 1796.563)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_445",
    "data-name": "Ellipse 445",
    transform: "translate(951.777 1796.563)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_9",
    "data-name": "Union 9",
    transform: "translate(938.068 1806.162)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.794,13.395a7.676,7.676,0,1,1,0-11.437,7.676,7.676,0,1,1,0,11.438Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.91284370422363 14.35156154632568 C 21.5938835144043 14.35156154632568 24.588623046875 11.35769081115723 24.588623046875 7.677731037139893 C 24.588623046875 3.995621204376221 21.5938835144043 1.000001192092896 17.91284370422363 1.000001192092896 C 16.26748275756836 1.000001192092896 14.68660354614258 1.604411244392395 13.46141338348389 2.701891183853149 L 12.79407405853271 3.299671173095703 L 12.12684345245361 2.701771259307861 C 10.90217399597168 1.604371309280396 9.321423530578613 1.000001192092896 7.675783634185791 1.000001192092896 C 3.994873523712158 1.000001192092896 1.000243544578552 3.995621204376221 1.000243544578552 7.677731037139893 C 1.000243544578552 11.35769081115723 3.994873523712158 14.35156154632568 7.675783634185791 14.35156154632568 C 9.321423530578613 14.35156154632568 10.90217399597168 13.74719142913818 12.12684345245361 12.6497917175293 L 12.79407405853271 12.0518913269043 L 13.46141338348389 12.64967155456543 C 14.68660354614258 13.74715137481689 16.26748275756836 14.35156154632568 17.91284370422363 14.35156154632568 M 17.91284370422363 15.35156154632568 C 15.94604396820068 15.35156154632568 14.15258312225342 14.61133098602295 12.79419326782227 13.39453125 C 11.43628406524658 14.61133098602295 9.642573356628418 15.35156154632568 7.675783634185791 15.35156154632568 C 3.436283588409424 15.35156154632568 0.0002435937494738027 11.91406154632568 0.0002435937494738027 7.677731037139893 C 0.0002435937494738027 3.437501192092896 3.436283588409424 1.249999968422344e-06 7.675783634185791 1.249999968422344e-06 C 9.642573356628418 1.249999968422344e-06 11.43628406524658 0.7402312755584717 12.79419326782227 1.95703125 C 14.15258312225342 0.7402312755584717 15.94604396820068 1.249999968422344e-06 17.91284370422363 1.249999968422344e-06 C 22.15234375 1.249999968422344e-06 25.588623046875 3.437501192092896 25.588623046875 7.677731037139893 C 25.588623046875 11.91406154632568 22.15234375 15.35156154632568 17.91284370422363 15.35156154632568 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M-2194.263,14907.81l-5.181-7.445",
    transform: "translate(3132.616 -13096.68)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M-2199.444,14907.81l5.181-7.445",
    transform: "translate(3162.04 -13096.68)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTypeIcon);
export default __webpack_public_path__ + "static/media/groupTypeIcon.a77874df7f8e4ab6cf4767fb821b4d9b.svg";
export { ForwardRef as ReactComponent };